var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 .002c3.854 0 7 2.831 7 6.352 0 3.522-3.146 6.353-7 6.353-.88 0-1.737-.147-2.539-.43l-.114-.042-.073.019-.113.032c-.083.024-.18.053-.292.088l-.226.072-.27.088c-.334.11-.74.248-1.216.413l-.584.203a.525.525 0 01-.678-.64l.194-.68c.1-.359.185-.665.253-.917l.097-.369.035-.14.028-.116C.537 9.178 0 7.805 0 6.354 0 2.833 3.146.002 7 .002zm-.004 3.902c-.663 0-1.05.442-1.05.814v.079a.525.525 0 11-1.05 0v-.079c0-1.106 1.023-1.864 2.1-1.864 1.076 0 2.1.758 2.1 1.864 0 .696-.37 1.222-.971 1.738l-.016.013c-.403.346-.588.504-.588.848v.315a.525.525 0 11-1.05 0v-.315c0-.844.552-1.307.892-1.593l.079-.066c.501-.43.604-.69.604-.94 0-.372-.387-.814-1.05-.814zm.597 5.338a.612.612 0 11-1.225 0 .612.612 0 011.225 0z",
    fill: "#575757"
  })));
}

export default SvgQuestion;